import { getReferrerOrigin } from "./referrerOrigin";
import { SHARE_REFERRER_PARAMETER } from "./shareVisitReferrer";

/** Leave the backend's picks wrapper before auth or analytics starts. */
export function redirectProductShareFrame(
  browser: Pick<Window, "location" | "top"> = window,
): boolean {
  const top = browser.top;
  if (!top || top === browser) return false;

  try {
    const current = new URL(browser.location.href);
    const match = current.pathname.match(/^\/product-share\/([^/]+)\/?$/);
    if (!match || match[1] === "dev-preview") return false;

    // Only our same-origin wrapper for this exact token may replace the top page.
    // Reading a third-party parent throws; leave other embeds alone.
    const parent = new URL(top.location.href);
    if (
      parent.origin !== current.origin
      || parent.pathname.replace(/\/$/, "") !== `/picks/${match[1]}`
    ) return false;

    const destination = new URL(parent.href);
    destination.pathname = current.pathname;
    // The wrapper drops its query and hash from the iframe URL. Restore them;
    // keep any frame-only parameters, with the original shared URL taking priority.
    current.searchParams.forEach((value, key) => {
      if (!parent.searchParams.has(key)) destination.searchParams.append(key, value);
    });
    destination.hash = parent.hash || current.hash;
    // Read the outer document: the iframe's referrer describes the wrapper, not the visitor's source.
    destination.searchParams.set(SHARE_REFERRER_PARAMETER, getReferrerOrigin(top.document.referrer));
    top.location.replace(destination.href);
    return true;
  } catch {
    return false;
  }
}
